module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/grid/flex-align-item/flex-align-item.component.scss
// module id = ./src/app/features/grid/flex-align-item/flex-align-item.component.scss
// module chunks = main